import SystemTypes from "../SystemTypes";

const getPosition = (min, max, defaultUserPositionTypes) => {
  const userPositionTypes =
    defaultUserPositionTypes ?? SystemTypes.UserPositionType;
  return Object.keys(userPositionTypes)
    .filter((x) => userPositionTypes[x] >= min && userPositionTypes[x] <= max)
    .map((y) => {
      return {
        label: y,
        value: userPositionTypes[y],
      };
    });
};

const getFieldName = (name, field) => {
  return field?.replace("*", name);
};

const getValue = (obj, name, field) => {
  const value = field?.replace("*", name);
  return obj?.[value];
};

export { getFieldName, getValue, getPosition };
